import get from 'lodash-es/get';
import { isObject } from './verify';

export function deepAssign(path, base, value) {
  if (path === '') {
    throw new Error('Cannot assign with empty path');
  }

  const levels = path.split(/\./);
  const final = levels.pop();

  const current = levels.reduce((visitor, level, idx) => {
    if (!isObject(visitor)) {
      throw new Error(`Cannot traverse past ${levels.slice(0, idx).join('.')}`);
    }
    return (visitor[level] = visitor[level] || {});
  }, base);

  return (current[final] = value);
}

export function deepExtract(path, base, defaultValue) {
  return get(base, path, defaultValue);
}
